import moment from 'moment'
import _ from 'lodash'
import PlanboardModeIdle from './PlanboardModeIdle'
import PlanboardModeBlock from './PlanboardModeBlock'
import PlanboardModeEditBooking from './PlanboardModeEditBooking'
import PlanboardModeChooseDeal from './PlanboardModeChooseDeal'
import PlanboardModeNewBooking from './PlanboardModeNewBooking'
import PlanboardModeShowBooking from './PlanboardModeShowBooking'

export default class Planboard {
  initFilters() {
    var self = this
    var $viewFilters = this.$elm.find('[name="planboardview[]"]')
    $viewFilters.on('change', function(e) {
      $viewFilters.each(function() {
        var $checkbox = $(this)

        if ($checkbox.prop('checked')) {
          self.$elm.addClass($checkbox.attr('data-class'))
        } else {
          self.$elm.removeClass($checkbox.attr('data-class'))
        }
      })
    })
  }

  addTimeslot() {
    $(_.template(window.templates.packageTableRow)())
      .appendTo(
        $('.planboard__package-selector.active').find('.planboard-package-selector__products'),
      )
      .find('[data-planboard-action="changetimeslot"]')
      .trigger('click')
    this.$activityRows.removeClass('planboard__activity--dimmed')
    this.setWrapperHeight()
  }

  constructor($elm) {
    var self = this
    this.$elm = $elm
    this.modes = {
      idle: new PlanboardModeIdle(this),
      newBooking: new PlanboardModeNewBooking(this),
      chooseDeal: new PlanboardModeChooseDeal(this),
      block: new PlanboardModeBlock(this),
      editBooking: new PlanboardModeEditBooking(this),
      showBooking: new PlanboardModeShowBooking(this),
    }
    $(document).on('keyup', this.keyup.bind(this))
    this.initFilters()

    // New booking selector
    this.$newBookingSelector = $elm.find('#planboard-new-booking-selector')
    this.$newBookingSelectorContent = this.$newBookingSelector.find(
      '.planboard__package-selector-content',
    )
    this.$newBookingButtons = $elm.find('.planboard__new-booking-buttons')
    this.$defaultButtons = $elm.find('.planboard__default-buttons')
    this.$activityRows = $elm.find('.planboard__activity')
    this.$workspaceWrapper = $elm.find('.planboard__workspace-wrapper')
    this.workspaceWrapperHeight = parseInt(this.$workspaceWrapper.attr('data-height'), 10)

    this.$packageSelector = $elm.find('#planboard-package-selector')
    this.$blockSlotsButtons = $elm.find('.planboard__block-slots-buttons')
    this.$blockSelectionButton = $elm.find('[data-planboard-action="blockselection"]')

    // Determine which action to take
    $(document).on('click', '.accordion', function(e) {
      let parentKey = $(this).data('activity-parent-key')
      let $children = $elm.find(
        '.planboard__activity[data-activity-parent-key="' + parentKey + '"]',
      )

      $children.each((key, elm) => {
        elm.classList.toggle('display-none')
      })
    })

    // Determine which action to take
    $(document)
      .on(
        'click',
        'a[data-planboard-action], button[data-planboard-action]',
        this.delegateAction.bind(this),
      )
      .on('submit', 'form[data-planboard-action]', this.delegateAction.bind(this))

    this.$elm.on('click', '.planboard-slot', function(evt, ui) {
      let $elm = $(this)
      let isParent = $elm.data('parent')

      if (isParent) {
        return
      }

      self.mode.slotClick($(evt.target).closest('.planboard-slot'), evt)
    })

    this.$elm.on('click', '[data-planboard-mode]', function(evt, ui) {
      var $elm = $(this)
      var modeName = $elm.data('planboard-mode')
      var args = $elm.data('planboard-mode-args')

      self.switchMode(modeName, args)
    })
    this.productGroups = []
    const planboardStartMode = this.$elm.data('planboard-start-mode')
    if (planboardStartMode) {
      this.switchMode(planboardStartMode)
    } else {
      this.switchMode(this.modes.idle)
    }
  }

  handle(action, $elm) {
    switch (action) {
      case 'block-slots':
        this.switchMode(this.modes.block)
        break
      case 'cancelblockslots':
        this.cancel()
        break
      case 'blockselection':
        this.mode.finish()
        break
      case 'changetimeslot':
        this.mode.changeTimeslot($elm)
        break
      case 'removeproductmodal':
        this.onRemoveProductModal($elm)
        break
      case 'adddealtimeslotmodal':
        this.onAddDealTimeslotModal($elm)
        break
      case 'removedealtimeslotmodal':
        this.onRemoveProductModal($elm, true)
        break
      case 'packagechosen':
        this.onPackageChosen($elm.productGroup)
        break
      case 'addtimeslot':
        this.addTimeslot()
        break
      case 'removeproduct':
        this.deleteProduct(...arguments)
        break
      case 'choosepackage':
        this.mode.onChoosePackage($elm.serialize())
        break
      case 'planner.submit':
        this.mode.book()
        break
      case 'planner.cancel':
        this.mode.clearWaitingSlot()
        this.cancel()
        break
      default:
        console.trace('unhandled action', action, $elm)
    }
  }

  cancel() {
    this.switchMode(this.modes.idle)
  }

  onPackageChosen(productGroup) {
    this.dirty = true
    this.checkIfPackageBookable()
    this.setWrapperHeight()
    this.productGroups.push(productGroup)
    this.mode.setProductGroupTitle()
    this.mode.update()
    this.setProductGroupsToExclude()
    var selector = '[data-product-group-key="' + productGroup.key + '"]'
    var prodRow = this.$elm.find(selector)
    var button = prodRow.find('[data-planboard-action="changetimeslot"]:first()')
    button.click()
  }

  setProductGroupsToExclude() {
    var $activeSelector = $('.planboard__package-selector.active'),
      $button = $activeSelector.find('[data-url*="choose-package"]'),
      $productGroupKeyRows = $activeSelector.find(
        '.planboard-package-product[data-product-group-key]',
      ),
      productGroupKeys = _.uniq(
        $productGroupKeyRows
          .map(function() {
            return 'exclude[]=' + $(this).attr('data-product-group-key')
          })
          .get(),
      ).join('&'),
      url = new URL($button.attr('data-url')),
      oldParams = new URLSearchParams(url.search)

    oldParams.delete('exclude[]')
    url.search = oldParams.toString()

    $button.attr('data-url', function(i, attr) {
      return url.toString() + '&' + productGroupKeys
    })
  }

  onRemoveProductModal($elm, forceRemoveProduct = false) {
    const self = this
    const $el = $elm,
      $elParent = $el.parents('[data-selected-slot]'),
      key = $elParent.attr('data-product-group-key'),
      type = key && !forceRemoveProduct ? 'deal' : 'product'

    self.deleteProduct = function() {
      if (type == 'deal') {
        $('.planboard-package-product[data-product-group-key="' + key + '"]').remove()
        _.remove(self.productGroups, function(productGroup) {
          return productGroup.key == key
        })
        self.mode.setProductGroupTitle()
        self.setProductGroupsToExclude()
      } else {
        $elParent.remove()
      }
      self.syncSelectorWithPlanboard()
      $('#briq-modal').modal('hide')
      self.dirty = true
      self.checkIfPackageBookable()
    }

    $('#briq-modal')
      .modal('show')
      .find('.modal__body')
      .html($(_.template(window.templates.removeProduct)({ type: type })))
      .trigger('bless')
  }

  onAddDealTimeslotModal($elm) {
    const $activeSelector = $('.planboard__package-selector.active')
    if ($activeSelector.length) {
      let highestDealCount = 0

      let dealCounts = $activeSelector
        .find('[data-deal]')
        .map(function() {
          return parseInt($(this).attr('data-deal'), 10)
        })
        .get()

      if (dealCounts.length) {
        highestDealCount = Math.max.apply(Math, dealCounts)
      }

      let data = {
        productGroupKey: $elm.attr('product-group-key'),
        productGroupProductKey: $elm.attr('product-group-product-key'),
        productKey: $elm.attr('product-key'),
        index: $('.planboard-package-selector__products tr').length,
        deal: highestDealCount,
      }
      $.get('/planboard/modal/deal-timeslot', data).then(
        function(value) {
          $activeSelector
            .find(
              '[data-product-group-product-key="' + $elm.attr('product-group-product-key') + '"]',
            )
            .last()
            .after(value.html)
        },
        function(jqXHR, textStatus, errorThrown) {
          console.error('Loading deal timeslot failed: ' + textStatus)
        },
      )
    }
  }

  checkIfPackageBookable() {
    const self = this
    const $rows = $('.planboard__package-selector.active').find('[data-needs-to-be-scheduled]'),
      $filledRows = $rows.filter(function() {
        return $(this).attr('data-selected-slot')
      })

    if (self.mode == self.modes.editBooking) {
      const $button = $('[data-button-type="update-booking"]')
      if (!$filledRows.length && !$rows.length) {
        $button.prop('disabled', true)
      } else {
        if (self.dirty && $filledRows.length == $rows.length) {
          $button.prop('disabled', false)
          $button.text('Change booking')
        } else {
          $button.prop('disabled', true)

          if ($rows.length - $filledRows.length > 0) {
            $button.text($rows.length - $filledRows.length + ' timeslots to select')
          } else {
            $button.text('Change booking')
          }
        }
      }
    } else {
      const $buttons = $(
        '[data-planboard-action="planner.submit"], [data-planboard-action="bookselection"]',
      )
      if (!$filledRows.length && !$rows.length) {
        $buttons.prop('disabled', true)
      } else {
        $buttons.prop('disabled', $filledRows.length !== $rows.length)
        if ($filledRows.length !== $rows.length) {
          $buttons.text($rows.length - $filledRows.length + ' timeslots to select')
        } else {
          $buttons.text('Create booking')
        }
      }
    }
  }

  setWrapperHeight() {
    const self = this
    self.$workspaceWrapper.height(function(index, height) {
      return (
        self.workspaceWrapperHeight + $('.planboard__package-selector.active').outerHeight() + 20
      )
    })
  }

  resetWrapperHeight() {
    this.$workspaceWrapper.height(this.workspaceWrapperHeight)
  }

  trigger(evt) {
    this.$elm.trigger(evt)
  }

  keyup(e) {
    if (e.which == 27) {
      //escape key
      this.cancel()
    }
  }

  switchMode(mode, args) {
    if (typeof mode == typeof '') {
      var modeName = mode
      mode = this.modes[modeName]
      if (!mode) {
        console.error(`No such mode "${modeName}"`)
        return
      }
    }

    if (this.mode) {
      this.mode.stop()
    }
    this.mode = mode
    this.mode.start(args)
    this.setWrapperHeight()
  }

  // Trigger event on planboard
  delegateAction(e) {
    const $elm = $(e.target)
    const action = $elm.attr('data-planboard-action')
    if (!action) {
      return
    }
    const data = {
      type: 'planboard.' + action,
      originalEvent: e,
    }
    if (e.type == 'submit') {
      data.formData = $elm.serialize()
    }
    this.handle(action, $elm)
    e.preventDefault()
  }

  // Planboard is loading new slots
  refreshing() {
    // eslint-disable-next-line no-undef
    $pointer.hide()
  }

  // Planboard is done loading new slots
  refreshed() {
    // eslint-disable-next-line no-undef
    $planboard.trigger('planboard.slots-changed')
    // eslint-disable-next-line no-undef
    $filter.find('[type="submit"]').prop('disabled', false)
  }

  slotsChanged() {
    this.mode.slotsChanged()
  }

  syncSelectorWithPlanboard() {
    this.$elm.find('.planboard-slot.selected').removeClass('selected')

    $('.planboard__package-selector.active .planboard-package-product').each(function() {
      const $el = $(this)
      let $slot = $('.planboard-slot[data-id="' + $el.attr('data-selected-slot') + '"]')
      const productDuration = parseInt($el.attr('data-duration'))
      const slotDuration = moment($slot.attr('data-duration'), 'kk:mm:ss')
      const slotDurationInMinutes = moment
        .duration({
          hours: slotDuration.hour(),
          minutes: slotDuration.minute(),
        })
        .asMinutes()
      const slotAmount = Math.ceil(productDuration / slotDurationInMinutes)

      if (slotAmount > 1) {
        $slot = $slot
          .nextAll()
          .addBack()
          .slice(0, slotAmount)
      }

      $slot.addClass('selected')
    })
  }

  modal(html) {
    const $modal = $('#briq-modal')

    $modal.modal({ show: true })
    $modal
      .find('.modal__body')
      .html(html)
      .trigger('bless')
  }
}
